import { render, staticRenderFns } from "./HolidayMenuButton.vue?vue&type=template&id=60d69d34"
import script from "./HolidayMenuButton.vue?vue&type=script&lang=js"
export * from "./HolidayMenuButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports